import Vue from "vue";
import "@js/filters.js";
import "@js/htmlFontSize.js";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@js/IsIphoneX";
import storage from "./util/storage";
import api from "./api"; // 导入api接口
// import VConsole from 'vconsole';
import Vant from "vant";
import "vant/lib/index.css";
import { i18n, vantLocales } from './lang'
// 引入模块后自动生效
import '@vant/touch-emulator';
import utils from "./util/utils.js"; // 获取url参数

Vue.use(Vant);
Vue.prototype.$eventBus = new Vue();
console.log('当前的语言是：', i18n.locale)
var isOldDomain = window.location.hostname === 'publication.sinokru.com';
console.log('isHttps', window.location.hostname);
console.log('isOldDomain', isOldDomain);

Vue.prototype.$utils = utils; // 注册全局方法

vantLocales(i18n.locale)
// new VConsole();
Vue.config.productionTip = false;
Vue.prototype.$storage = storage; // 保存到内存storage
Vue.prototype.$api = api; // 将api挂载到vue的原型上
new Vue({
  router,
  store,
  i18n: i18n,
  render: h => h(App)
}).$mount("#app");
